import { Component, OnInit, EventEmitter, Output, ViewChild, Input } from '@angular/core';
import { AuctionModel, AuctionModelService } from '../../model/auction.model';
import { FeatureFlagService } from '../../services/feature-flag.service';

export const SHOT_CLOCK_MODE_FLAG = 'release-shot-clock-mode';

@Component({
  selector: 'app-auctionconfigure',
  templateUrl: './auctionconfigure.component.html',
  styleUrls: ['./auctionconfigure.component.scss']
})
export class AuctionconfigureComponent implements OnInit {
  errorMsg = "";
  processing: boolean = false;
  @Output() messageEvent = new EventEmitter<any>();
  @Input() savedisabled:boolean = false;

  auctionTypes = [];
  commissionTypes = [];
  bankAccountTypes = [];
  extensionPeriodIntervals = [];
  shotClockExtensionIntervals = [];
  
  closingExtensionStyle:boolean;

  // Exposed so specs can await the async flag evaluation before asserting on auctionTypes.
  featureFlagsReady: Promise<void>;

  constructor(
    public auctionModel:AuctionModelService,
    private featureFlagService: FeatureFlagService
  ) { }

  /**
   * angular (ng) initializers
   **/
  ngOnInit(): void {
    this.commissionTypes = AuctionModel.COMMISSION_TYPES;
    this.bankAccountTypes = AuctionModel.BANK_ACCOUNT_TYPES;
    this.extensionPeriodIntervals = AuctionModel.EXTENSION_PERIOD_INTERVALS;
    this.shotClockExtensionIntervals = AuctionModel.SHOT_CLOCK_EXTENSION_INTERVALS;
    this.featureFlagsReady = this.applyShotClockVisibility();
  }

  // Fail-closed direction: the list excludes Shot Clock until the flag resolves, not just
  // when it resolves to off. AuctionModel.AUCTION_TYPES (the shared static source) is read,
  // never mutated, so other consumers of that static array are unaffected.
  private applyShotClockVisibility(): Promise<void> {
    this.auctionTypes = this.filterAuctionTypes(false);
    return this.featureFlagService.enabled(SHOT_CLOCK_MODE_FLAG).then((shotClockModeOn) => {
      this.auctionTypes = this.filterAuctionTypes(shotClockModeOn);
    });
  }

  private filterAuctionTypes(shotClockModeOn: boolean) {
    return AuctionModel.AUCTION_TYPES.filter((item) => shotClockModeOn || item.key !== 'SHOT_CLOCK');
  }

  isShotClock(){
    return this.auctionModel.activeAuction && this.auctionModel.activeAuction.type === 'SHOT_CLOCK';
  }
  
  /**
   * html page handlers
   **/
  onSaveAuction(){
    var eventMsg = {}
    eventMsg['message'] = 'saveauction';
    this.messageEvent.emit(eventMsg);
  }
  
  validPhone(){
    var phone = this.auctionModel.activeAuction.salesRepContact;
    var returnValue = false;
    if(phone == undefined || phone.length == 0){
      returnValue = true;
    }
    else if(phone.length == 14){
      returnValue = /^\(\d{3}\)\s\d{3}-\d{4}/g.test(phone);
    }
    return returnValue;
  }
  
  validEmail() {
    var returnValue = true;
    if(this.auctionModel.activeAuction.salesRepEmail != undefined && this.auctionModel.activeAuction.salesRepEmail.length > 0){
      const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/g;
      returnValue = re.test(String(this.auctionModel.activeAuction.salesRepEmail).toLowerCase());
      
    }
    return returnValue;
  }  
  
  validateFormData(){
    var returnValue = this.validPhone() && this.validEmail();
    const auction = this.auctionModel.activeAuction;
    if(auction.commissionType != undefined && !(auction.commissionValue > 0)){
      returnValue = false;
    }
    if(this.isShotClock()){
      const period = auction.defaultLotOpenBiddingPeriodMinutes;
      if(period == undefined || period < 1 || period > 9999){
        returnValue = false;
      }
    }
    return returnValue;    
  }
  
  onCustomTermsAndConditionsCheckbox($event){
    this.auctionModel.activeAuction.customTermsAndConditions = null;
  }

  onCustomDeliveryAndPaymentTermsCheckbox($event){
    this.auctionModel.activeAuction.customDeliveryAndPaymentTerms = null;
  }

}
